import DynamicData from "../../../../editors/dynamic/data";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";

export default function Dynamic({ condition, onChange, sources = [] }) {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (Array.isArray(condition.value)) {
      setValue(condition.value);
    } else {
      handleSave([{}]);
    }
  }, [condition]);

  const handleSave = (value) => {
    const _condition = { ...condition };
    _condition.value = value;
    onChange(_condition);
  };

  if (!value) {
    return null;
  }
  return (
    <div className={styles.media}>
      <div className={styles.propTitle}>Value when true</div>
      <DynamicData
        value={value}
        onChange={(v) => handleSave(v)}
        params={{ type: "True/False", list: false }}
        sources={sources}
      />
    </div>
  );
}
